// extracted by mini-css-extract-plugin
module.exports = {"chip":"styles_chip__X3oND","fadeInOut":"styles_fadeInOut__Yoite","loader":"styles_loader__I5if3"};